import { createFileRoute } from '@tanstack/react-router'

// Critical (non-lazy) part of the route: only what the router needs to match the
// URL. The page component and its heavy calendar code live in `route.lazy.tsx` so
// they load as a separate chunk (and future sibling routes like `/join/$call` never
// ship the booking bundle).
export const Route = createFileRoute('/book/$token')({
	head: () => ({
		meta: [{ title: 'Book your interview · Jobilla' }],
	}),
})
